import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import quizReducer from './slices/quizSlice';

/**
 * Redux Store Configuration
 * 
 * Using Redux Toolkit's configureStore which includes:
 * - Redux DevTools Extension integration
 * - Thunk middleware for async actions
 * - Immutability checks in development
 * - Serializable state invariant middleware
 */

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    quiz: quizReducer,
    // Future slices will be added here:
    // contact: contactReducer,
    // user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializable check
        ignoredActions: ['ui/addToast'],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
